export default __webpack_public_path__ + "static/media/default-image.322da084.png";